export const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'proton.me',
  'protonmail.com',
  'mail.com',
  'zoho.com',
  'yandex.com',
  'gmx.com',
]);

/**
 * Returns the lowercased domain portion of an email address, or `''` when the
 * input is empty or has no `@`. Used to sanitise recipient PII before it
 * reaches analytics — only the domain leaves the client, never the full address.
 */
export const getEmailDomain = (email: string): string => {
  if (!email || typeof email !== 'string') return '';
  return email.toLowerCase().split('@')[1] ?? '';
};

export const isPersonalEmailDomain = (email: string): boolean => {
  if (!email || typeof email !== 'string') return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) return false;

  const domain = email.toLowerCase().split('@')[1];
  return domain ? FREE_EMAIL_DOMAINS.has(domain) : false;
};
